"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var SplitButton_1 = require("./SplitButton");
var Button_1 = require("./Button");
var FillSpace_1 = require("./FillSpace");
var Separator_1 = require("./Separator");
var Text_1 = require("./Text");
var types_1 = require("../types");
exports.ToolbarControls = (_a = {},
    _a[types_1.TOOLBAR_ITEM_TYPE.button] = Button_1.Button,
    _a[types_1.TOOLBAR_ITEM_TYPE.fillSpace] = FillSpace_1.FillSpace,
    _a[types_1.TOOLBAR_ITEM_TYPE.separator] = Separator_1.Separator,
    _a[types_1.TOOLBAR_ITEM_TYPE.text] = Text_1.Text,
    _a);
exports.ToolbarControlsWithGroup = (_b = {},
    _b[types_1.TOOLBAR_GROUP_TYPE.splitButton] = SplitButton_1.SplitButton,
    _b);
//# sourceMappingURL=ToolbarControls.js.map